import { MatIconDefaultOptions } from "@angular/material/icon";

export const PB_ICON_CONFIG: MatIconDefaultOptions = { fontSet: "pb" };
